var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, default as React } from "react";
import { bind } from "decko";
import Icon from "./icon";
import { SortDirection } from "../models/sorting";
import { FlexContainer } from "../barrel";
export class SortableTableHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sorting: props.sorting,
        };
    }
    handleTableHeaderClick() {
        const sortDirection = this.state.sorting[0] === SortDirection.DESC
            ? SortDirection.ASC
            : SortDirection.DESC;
        const sorting = [sortDirection, this.state.sorting[1]];
        this.setState({
            sorting: sorting,
        });
        this.props.sorter(sorting);
    }
    renderSortDirection() {
        if (this.props.sortingActive(this.props.sorting[1])) {
            return (React.createElement(FlexContainer, { "md-align": "center" },
                "\u00A0",
                this.state.sorting[0] === SortDirection.DESC ? (React.createElement(Icon, { size: "small", name: "arrow_downward" })) : (React.createElement(Icon, { size: "small", name: "arrow_upward" }))));
        }
        return null;
    }
    render() {
        return (React.createElement("th", { style: { cursor: "pointer" }, onClick: this.handleTableHeaderClick },
            React.createElement(FlexContainer, { direction: "row" },
                this.props.label,
                " ",
                this.renderSortDirection())));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SortableTableHeader.prototype, "handleTableHeaderClick", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SortableTableHeader.prototype, "renderSortDirection", null);
//# sourceMappingURL=sortable-table-header.js.map